import {createPopup} from "./popup-new";
export interface IShowContentDialogDependencies {
	readonly dialogId: string;
	readonly label?: string;
	readonly title?: string;
	readonly cssClass?: string;
	readonly openFunction?: () => void;
}

export function ShowContentDialog(deps: IShowContentDialogDependencies) {

	const { label, title, dialogId, cssClass, openFunction } = deps;
	if (!dialogId) return;

	createPopup({
		sendToNetCoreSite: true,
		dialogId: dialogId,
		view: 'GenericPopup',
		data: {
			BodyLabel: label?.startsWith('Label.') ? label : `Label.${label}`,
			TitleLabel: title?.startsWith('Label.') ? title : `Label.${title}`,
			TitleCssClass: 'a-typography__no-decoration technical-popup-title'
		},
		cssClass: cssClass,
		closeOnClickOutsidePopup: true,
		forceRefresh: true
	}).then(popup => {
		popup.openAsync();
		if (openFunction)
			openFunction();
	});
}
